import styled, { css } from 'styled-components';

import { breakpoints } from '@shared/constants';

export const ListItem = styled.div(
    ({ theme: { boxShadow, palette } }) => css`
        align-items: center;
        background: ${palette.neutral.white};
        box-shadow: ${boxShadow.small};
        display: flex;
        margin-bottom: 5px;
        padding: 18px 24px;
        position: relative;

        @media (max-width: ${breakpoints.sm}px) {
            padding: 20px 16px;
        }

        &:hover {
            box-shadow: ${boxShadow.small};
            z-index: 9;
        }
    `,
);

const ListItemCell = styled.div`
    letter-spacing: -0.015em;
    margin-right: 20px;
`;

export const ReportCell = styled(ListItemCell)`
    flex: 1;
`;

export const StatusCell = styled(ListItemCell)`
    flex: 1;
`;

export const MessageCell = styled(ListItemCell)`
    flex: 3;

    @media (max-width: ${breakpoints.sm}px) {
        flex: 1;
    }
`;

export const DateCell = styled(ListItemCell)(
    ({ theme: { palette } }) => css`
        color: ${palette.text.assistive};
        flex: 1;

        @media (max-width: ${breakpoints.md}px) {
            display: none;
        }
    `,
);
